import { Building2, User } from 'lucide-react';
import type { SocialProfile } from 'v5/core/contact-details/social/abstractLinkResolver';

/** A profile's bare name with a person or company icon (LinkedIn). */
export function SocialProfileHandle({ profile }: { profile: SocialProfile }) {
  const Icon = profile.kind === 'company' ? Building2 : User;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <Icon size={14} />
      {profile.name}
    </span>
  );
}
